export const csrfMatches = () => {
  if (typeof window === 'undefined') return ['', ''];
  const csrfmatches = window.document.cookie.match(/cr00=([a-z0-9-]+)/i);
  if (!csrfmatches || !csrfmatches.length) return ['', ''];
  return csrfmatches;
};

export default csrfMatches;
